export default "__VITE_ASSET__BVdtWtls__"